export const data = {
    Human: "Homo sapiens",
    Dog: "Canis lupus familiaris",
    Cat: "Felis catus",
    Pig: "Sus scrofa",
    "Domestic Yak": "Bos grunniens",
    Cattle: "Bos taurus",
    Chicken: "Gallus gallus",
    Goat: "Capra hircus",
    Sheep: "Ovis aries",
    Horse: "Equus caballus",
    "Water Buffalo": "Bubalus bubalis",
    "Honey Bee": "Apis melifera",
    tverrucosum: "Trichophyton verrucosum",
}












